import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    text: 'La primera noche que hice la descarga me dormí en 20 minutos. Llevaba 3 semanas sin poder dormirme antes de las 2 AM. No puedo creer que algo tan simple funcione tan rápido.',
    author: 'Valentina R.',
    meta: '34 años, Buenos Aires'
  }, {
    text: 'Siempre pensé que era ansioso y que no había nada que hacer. Este sistema me mostró que el problema no era yo. Era que nunca le avisaba a mi cabeza que el día había terminado. Ahora duermo. De verdad.',
    author: 'Martín G.',
    meta: '29 años, Córdoba'
  }, {
    text: 'Me despertaba todas las noches a las 3 AM y ya no podía volver a dormirme. Con el bonus de despertares de madrugada aprendí exactamente qué hacer. Ya no entro en pánico. Y la mayoría de las noches vuelvo a dormirme en menos de 15 minutos.',
    author: 'Carolina M.',
    meta: '38 años, Rosario'
  }, {
    text: 'Probé meditaciones, apps, infusiones, todo. Nada me funcionaba más de 2 días. Este sistema es diferente porque te explica por qué pasa lo que te pasa. Y cuando lo entendés, todo tiene sentido. Llevo 3 semanas durmiendo mucho mejor.',
    author: 'Diego F.',
    meta: '41 años, Mendoza'
  }, {
    text: 'Lo compré un domingo a las 11 de la noche porque no podía dormir. Lo abrí. Hice la descarga. Me acosté. Me dormí en 25 minutos. Nunca me pasó algo así. Los 19.999 son la mejor inversión que hice en años.',
    author: 'Lucía T.',
    meta: '26 años, CABA'
  }];
  return <Section darker data-id="element-327">
      <div className="max-w-5xl mx-auto" data-id="element-328">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-white" data-id="element-329">
          Lo que dicen las personas que ya lo usaron
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-330">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`bg-night-800 p-8 rounded-2xl border border-night-700 ${idx === 4 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-331">
              <div className="flex gap-1 mb-4 text-cta" data-id="element-332">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-333" />)}
              </div>
              <p className="text-gray-300 text-lg italic mb-6" data-id="element-334">"{t.text}"</p>
              <div data-id="element-335">
                <p className="text-white font-bold" data-id="element-336">{t.author}</p>
                <p className="text-gray-500 text-sm" data-id="element-337">{t.meta}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
};